export default "__VITE_ASSET__d5b7f8b4__"